import {outter_post} from 'common/js/axios-helper';
import {ChannelApi} from "./constant/UrlMapper";


const host = '8880';
const host2 = '8885';

const tatTaxJumpLineList = (data) => {
    return outter_post(ChannelApi.TatTaxJumpLineList, data, host2);
};

const tatTaxJumpLineAdd = (data) => {
    return outter_post(ChannelApi.TatTaxJumpLineAdd, data, host2);
};

const tatTaxJumpLineEdit = (data) => {
    return outter_post(ChannelApi.TatTaxJumpLineEdit, data, host2);
};

const tatTaxJumpLineDel = (data) => {
    return outter_post(ChannelApi.TatTaxJumpLineDel, data, host2);
};




export default {  tatTaxJumpLineList, tatTaxJumpLineAdd, tatTaxJumpLineEdit, tatTaxJumpLineDel}



// WEBPACK FOOTER //
// ./src/service/ChannelService.js